<template>
    <button @click="generatePDF">TEST</button>
</template>
  
<script>
    import pdfMake from "pdfmake/build/pdfmake";
    import pdfFonts from "pdfmake/build/vfs_fonts";
      import ListsMixin from '@/mixins/ListsMixin'
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    
  
    function getLogo() {
        var request = new XMLHttpRequest()
        request.open('GET', 'https://api.tb-cms.org/vueimages/logo.txt', false)
        request.send(null)
        if (request.readyState === 4) {
            if (request.status === 200 && request.statusText === 'OK') {
                var type = request.getResponseHeader('Content-Type')
                if (type.indexOf('text') !== 1) {
                    return request.responseText
                }
            } else {
                return ''
            }
        }
        return request.responseText
    };

    var logoImage = getLogo()
    logoImage = logoImage.split('\n')

    function dynamicSort(property, property2) {
        var sortOrder = 1
        if (property[0] === '-') {
            sortOrder = -1
            property = property.substr(1)
        }
        return function (a, b) {
            // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            if (a[property] > b[property]) return 1
            if (a[property] < b[property]) return -1
            if (a[property2] > b[property2]) return 1
            if (a[property2] < b[property2]) return -1
            // return result * sortOrder;
        }
    }

    export default {
        name: 'PDFGenerator',
        mixins: [ListsMixin],
        props: [
            'item',
            'small',
            'light',
            'title',
            'subtitle',
            'created_by',
            'created_at',
            'page_no',
            'showNoOfArtworks',
            'sort',
            'subsort',
            'columns',
        ],
        data() {
            return {
                logo: logoImage,  // Base64 encoded image data for logo
                docName: 'Document Name',
                artworks: [  // Dummy array of artwork objects
                    { number: '1', name: 'Artwork 1', artist: 'Artist 1', image: logoImage },
                    { number: '2', name: 'Artwork 2', artist: 'Artist 2', image: logoImage },
                    { number: '3', name: 'Artwork 3', artist: 'Artist 3', image: logoImage },
                ],
                constants: constants,
                loading: false,
                outputFields: ['classification', 'ownership'],
                output_fields: [],
                list_settings: {
                use_current_selection: false,
                use_current_list_selection: false,
                financial_information: false,
                image: false,
                compact: false,
                table: true,
                view: 'table',
                sort: 'sort_name',
                add_empty_column: false,
                },
                add_empty_column: false,
                imageSize1: '240',
                imageSize2: '240',
                pdf_artworks: [],

            };
        },
        mounted() {
            this.output_fields = this.columns
            // Object.assign(
            //   [],
            //   this.$store.state.currentOutputFieldsSelection
            // )
        },
        methods: {
            pdfSoloCall(full) {
                this.loading = true
                setTimeout(
                    function () {
                    setTimeout(
                        function () {
                        this.pdf(full)
                        this.loading = false
                        }.bind(this),
                        0
                    )
                    }.bind(this),
                    500
                )
                },

            pdf(full) {
                let docDefinition = {
                    pageSize: 'A4',
                    pageMargins: [40, 40, 40, 40],
                    header: (currentPage, pageCount) => {
                        if (currentPage !== 1) {
                        return [
                            {
                            table: {
                                widths: ['66.66%', '33.33%'],
                                body: [
                                [{ text: '', border: [false, false, false, false] }, { image: this.logo, width: 200, height: 50, border: [false, false, false, false] }]
                                ]
                            },
                            layout: 'noBorders',
                            margin: [0, 0, 0, 40],
                            },
                        ];
                        }
                        return [];
                    },
                    footer: function(currentPage, pageCount) {
                        return { text: currentPage.toString() + ' of ' + pageCount, alignment: 'center' };
                    },
                    info: {
                        title: list_name,
                        author: username,
                        subject: list_name,
                        keywords: 'artwork names, artist names',
                        creationDate: created,
                    },
                    styles: {
                        title: {
                        fontSize: 14,
                        all_caps: true,
                        alignment: 'right',
                        bold: true,
                        margin: [0, 33, 0, 0],
                        },
                        titleS: {
                        fontSize: 14,
                        all_caps: true,
                        alignment: 'right',
                        margin: [0, 33, 0, 0],
                        },
                        titleSub: { fontSize: 9, all_caps: true, alignment: 'right' },
                        titleDate: { fontSize: 9, alignment: 'right', bold: false },
                        createdAt: { fontSize: 9, alignment: 'right' },
                        createdBy: { fontSize: 9, alignment: 'right' },
                        bold: { fontSize: 9, bold: false },
                        normal: { fontSize: 9, bold: false },
                        artwork_title: { fontSize: 9, bold: true, margin: [0, 0, 0, 0] },
                        artwork_title_top: {
                        fontSize: 9,
                        bold: false,
                        margin: [0, 0, 0, 0],
                        },
                        artist_name: { fontSize: 9, italic: true, margin: [0, 25, 0, 0] },
                        image: { alignment: 'center', margin: [0, 0, 0, 0] },
                        logo: { alignment: 'left', margin: [0, 0, 0, 40] },
                    },

                    content: [
                        {
                        image: this.logo,
                        width: 200,
                        height: 50
                        },
                        {
                        text: this.docName,
                        fontSize: 20,
                        margin: [0, 0, 0, 10]
                        },
                        {
                        text: 'Number of items: ' + this.artworks.length,
                        fontSize: 12,
                        margin: [0, 0, 0, 40]
                        },
                    ],
                };

                let artworksData = [];
                this.artworks.forEach((artwork, index) => {
                    let page = Math.floor(index / (index < 3 ? 3 : 4)) + 1;
                    if (!artworksData[page]) artworksData[page] = [];

                    artworksData[page].push([
                        { text: artwork.number + '\n' + artwork.name + '\n' + artwork.artist, border: [false, false, false, false], alignment: 'top' },
                        { image: logoImage, fit: [100, 100], border: [false, false, false, false], alignment: 'top' }
                    ]);

                    if ((index + 1) % (index < 3 ? 3 : 4) === 0) artworksData[page].push([]);
                });

                artworksData.forEach((artworks, index) => {
                    if (index === 0) docDefinition.content.push({ table: { widths: ['66.66%', '33.33%'], body: artworks }, layout: 'noBorders' });
                    else docDefinition.content.push({ table: { widths: ['66.66%', '33.33%'], body: [
              [{ text: artwork.number + '\n' + artwork.name + '\n' + artwork.artist, border: [false, false, false, false] }, { image: artwork.image, fit: [100, 100], border: [false, false, false, false] }]
            ] }, layout: 'noBorders', pageBreak: 'before' });
                });

    //     artworksData[page].push({
    //       table: {
    //         widths: ['66.66%', '33.33%'],
    //         body: [
    //           [{ text: artwork.number + '\n' + artwork.name + '\n' + artwork.artist, border: [false, false, false, false] }, { image: artwork.image, fit: [100, 100], border: [false, false, false, false] }]
    //         ]
    //       },
    //       layout: 'noBorders',
    //       margin: [0, 0, 0, 40],
    //     });

    //     if ((index + 1) % (index < 3 ? 3 : 4) === 0) artworksData[page].push({ text: '', pageBreak: 'after' });
    //   });

    //   artworksData.forEach((artworks, index) => {
    //     if (index === 0) docDefinition.content.push(...artworks);
    //     else docDefinition.content.push({ stack: artworks, pageBreak: 'before' });
    //   });
                pdfMake.createPdf(docDefinition).download();
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/lists/TestList.vue